import useGet from "../../useGet";

const useGetUserRoles = () => {
  const { data } = useGet({
    url: "auth/roles",
    initialParams: {},
    onSuccess: (data) => {},
    onError: (error) => {},
  });

  const userRoles = data?.data?.data || [];

  return { userRoles };
};

export default useGetUserRoles;
